import React, { useContext } from 'react';
import { Row, Col, Tag, Alert } from 'antd';
import { DistanceContext } from '../distanceContext';
import MapView from './map';

import './index.scss';

const DistanceView = () => {
  const { current } = useContext(DistanceContext);

  return (
    <div className="distance-container">
      <div className="header">
        {current.name ? (
          <Row gutter={24}>
            <Col flex="auto">
              <div className="cutoff-distances-tag-colors">
                <Tag
                  color="#f5f5f5"
                  style={{ color: '#000', border: '1px solid #d7d4d4' }}
                >
                  Seçili İl: {current.name}
                </Tag>
                <Tag
                  color="#ffe7ba"
                  style={{ color: '#000', border: '1px solid #f1f1cc' }}
                >
                  1 Gün
                </Tag>
                <Tag color="#8b7355">2 Gün</Tag>
                <Tag color="#0066a9">3 Gün</Tag>
                <Tag color="#1a8503">4 Gün</Tag>
                <Tag color="#9702a5">5 Gün</Tag>
                <Tag color="#e10202">6 Gün</Tag>
                <Tag color="#828282 ">7 Gün</Tag>
                <Tag color="#fb9201">8 Gün</Tag>
              </div>
            </Col>
          </Row>
        ) : (
          <Row gutter={24}>
            <Col>
              <Alert
                showIcon
                style={{ marginBottom: 10, padding: '2px 15px' }}
                message="İller arası mesafeyi görüntüleyebilmek için lütfen haritadan
                  bir il seçimi yapınız."
                type="warning"
              />
            </Col>
          </Row>
        )}
      </div>
      <MapView />
      {current?.name && (
        <Row gutter={24}>
          <Col>
            <Alert
              showIcon
              style={{ marginBottom: 10, padding: '2px 15px' }}
              message="Bu rapordaki süreler genel bilgilendirme amaçlıdır. İlçe bazlı istisnai durumlar olabilir."
              type="info"
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default DistanceView;
